var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SimpleCard',{attrs:{"title":_vm.schema.title,"schema":_vm.schema}},[_c('DynamicDetailsPage',{attrs:{"schema":_vm.schema,"service":_vm.service,"type-page":_vm.typePage},on:{"save":_vm.save}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }